import { Flex } from '../../component-library';
import { DefaultButton } from '../../components';

const ScreenCalibration = ({ setStep, postMessage }) => {
  const handlePatient = (e) => {
    const messageContent = {
      type: 'cardCalibration',
      content: {
        screen: e,
      },
    };
    postMessage(messageContent);
    setStep(e);
  };

  return (
    <Flex>
      <DefaultButton
        onClick={() => {
          handlePatient('card');
        }}
        text='Use Card'
        height='120px'
        width='260px'
      />
      <DefaultButton
        onClick={() => {
          handlePatient('ruler');
        }}
        text='Use Ruler'
        height='120px'
        width='260px'
        ml='15px'
      />
    </Flex>
  );
};

export default ScreenCalibration;
